import { createAction, props } from '@ngrx/store';
import type { NmoBaseRouterStoreState } from '@candyland/angular/shared/data-access-nmo';
import type { InitParams } from '@candyland/angular/shared/showcase/util';

export const showCasePageView = createAction(
  '[Showcase] Page view from Showcase',
  props<{ payload: { articlePageView: NmoBaseRouterStoreState } }>()
);

export const showCaseEAInit = createAction(
  '[Showcase] Extended Access Lib Init Called',
  props<{ payload: { dynamicInitParams: InitParams } }>()
);
